/*
  Membership modal (sections/membership-modal.liquid). Plain ES5 for old in-app WebViews.
  Page and enabled checks happen in Liquid; this file handles paid traffic, the
  end date, once-a-day frequency, when it opens and the form.

  When it opens (data-trigger):
  - "after_add_to_cart" (default): a few seconds after a successful add to cart
    (assets/cart-events.js), once the cart drawer is closed again, or on exit
    intent (mouse leaving through the top of the window, desktop only). It no
    longer pops up in the middle of an add to cart.
  - "timer": after data-delay seconds on the site, counted from the first page
    of the browser session (not per page, few visitors stay 2 minutes on one
    page), so it can open on whatever page the visitor is on by then.
  Either way it never opens on top of the cart drawer; it waits until it closes.
*/
(function () {
  'use strict';

  var PAID_FLAG = 'nooriaPaidVisit';
  var LAST_SHOWN = 'modalLastShown'; // kept from the old modal so people aren't re-shown
  var SESSION_START = 'nooriaSessionStart';

  function storageGet(store, key) {
    try { return window[store].getItem(key); } catch (e) { return null; }
  }

  function storageSet(store, key, value) {
    try { window[store].setItem(key, value); } catch (e) {}
  }

  // A visit that starts from an ad keeps the flag for the whole browser session,
  // so the modal stays off on every page the visitor opens next.
  function isPaidVisit() {
    if (storageGet('sessionStorage', PAID_FLAG) === '1') return true;
    var params = window.location.search.toLowerCase();
    var paid = /[?&](gclid|gbraid|wbraid|fbclid|msclkid|ttclid)=/.test(params) ||
      /[?&]utm_medium=(cpc|ppc|paid|paid_social|paidsocial|paid-social|display)(&|$)/.test(params);
    if (paid) storageSet('sessionStorage', PAID_FLAG, '1');
    return paid;
  }

  function shownToday() {
    var last = storageGet('localStorage', LAST_SHOWN);
    return !!last && new Date(last).toDateString() === new Date().toDateString();
  }

  function beforeEndDate(showUntil) {
    if (!showUntil) return true;
    var parts = showUntil.split('-');
    var end = new Date(+parts[0], +parts[1] - 1, +parts[2], 23, 59, 59);
    return new Date() <= end;
  }

  // Start of the visit, for the "timer" trigger. Kept for the browser session.
  function sessionStart() {
    var now = new Date().getTime();
    var start = parseInt(storageGet('sessionStorage', SESSION_START), 10);
    if (isNaN(start) || start > now) {
      start = now;
      storageSet('sessionStorage', SESSION_START, String(start));
    }
    return start;
  }

  function init() {
    // Record paid landings and the visit start first, also on pages where the modal is switched off.
    var paid = isPaidVisit();
    var startedAt = sessionStart();
    var modal = document.getElementById('membershipModal');
    if (!modal) return;
    var designMode = modal.getAttribute('data-design-mode') === 'true';

    var form = modal.querySelector('#membership-form');
    var submit = form.querySelector('button[type="submit"]');
    var loader = submit.querySelector('.loader');
    var error = modal.querySelector('#membership-form-error');

    function open() {
      modal.classList.add('active');
      if (typeof window.clarity === 'function') window.clarity('event', 'membership_modal_shown');
    }

    function close() {
      modal.classList.remove('active');
      storageSet('localStorage', LAST_SHOWN, new Date().toISOString());
    }

    function setLoading(on) {
      submit.disabled = on;
      if (loader) loader.style.display = on ? 'block' : 'none';
      if (on && error) error.innerText = '';
    }

    modal.querySelector('.close-button').addEventListener('click', close);
    modal.querySelector('.membership-modal__overlay').addEventListener('click', close);

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      setLoading(true);
      var data = {};
      var fields = form.elements;
      for (var i = 0; i < fields.length; i++) {
        if (fields[i].name) data[fields[i].name] = fields[i].value;
      }
      fetch(form.action, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      }).then(function (res) {
        if (!res.ok) return res.text().then(function (text) { throw text; });
        return res.json();
      }).then(function () {
        setLoading(false);
        if (typeof window.clarity === 'function') window.clarity('event', 'membership_registered');
        close();
      }).catch(function (text) {
        var message = 'Something went wrong. Please try again.';
        try { message = JSON.parse(text).message || message; } catch (err) {}
        if (error) error.innerText = message;
        setLoading(false);
      });
    });

    if (designMode) return; // shown via the editor's section select instead

    if (modal.getAttribute('data-hide-for-paid') === 'true' && paid) return;
    if (!beforeEndDate(modal.getAttribute('data-show-until'))) return;
    if (shownToday()) return;

    var opened = false;
    var addTimer = null;

    // Never on top of the cart drawer.
    function busy() {
      return document.body.classList.contains('page-overlay-cart-on') ||
        !!document.querySelector('.wt-cart__drawer--open');
    }

    function openOnce() {
      if (opened || shownToday()) return;
      if (busy()) {
        // Try again once the visitor closes the drawer.
        addTimer = setTimeout(openOnce, 2000);
        return;
      }
      opened = true;
      document.removeEventListener('mouseout', onMouseOut);
      open();
    }

    if (modal.getAttribute('data-trigger') === 'timer') {
      var delay = parseInt(modal.getAttribute('data-delay'), 10);
      if (isNaN(delay)) delay = 120;
      var remaining = Math.max(0, delay * 1000 - (new Date().getTime() - startedAt));
      addTimer = setTimeout(openOnce, remaining);
      return;
    }

    var afterAdd = parseInt(modal.getAttribute('data-delay-after-add'), 10);
    if (isNaN(afterAdd)) afterAdd = 5;
    document.addEventListener('nooria:cart-added', function () {
      if (opened) return;
      clearTimeout(addTimer);
      addTimer = setTimeout(openOnce, afterAdd * 1000);
    });

    // Exit intent: desktop only (a fine pointer), and not in the first seconds.
    var exitReadyAt = new Date().getTime() + 5000;
    function onMouseOut(e) {
      if (e.relatedTarget || e.toElement || e.clientY > 0) return;
      if (new Date().getTime() < exitReadyAt) return;
      openOnce();
    }
    var finePointer = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (modal.getAttribute('data-exit-intent') === 'true' && finePointer) {
      document.addEventListener('mouseout', onMouseOut);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor: open the modal while its section is selected.
  document.addEventListener('shopify:section:select', function (e) {
    var modal = document.getElementById('membershipModal');
    if (modal && e.target.contains(modal)) modal.classList.add('active');
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    var modal = document.getElementById('membershipModal');
    if (modal && e.target.contains(modal)) modal.classList.remove('active');
  });
})();
